import React, { memo } from 'react';
import { Table, Box, Space, Flex, Title } from '@mantine/core';
// import classes from "./ProducTable.module.css"

interface ProductTableProps {
    data?: any;
}

const TableTransport: React.FC<ProductTableProps> = ({
    data
}) => {
    const rows = Array.isArray(data)
    ? data.flatMap((journey: any) =>
        Array.isArray(journey.ComputeTransports)
          ? journey.ComputeTransports.map((transport: any, index: number) => (
              <Table.Tr key={transport.id}>
                <Table.Td>{index === 0 ? journey.id : ''}</Table.Td>
                <Table.Td>{index === 0 ? journey.no_of_times : ''}</Table.Td>
                <Table.Td>{transport.journey_type}</Table.Td>
                <Table.Td>{transport.source_location}</Table.Td>
                <Table.Td>{transport.destination_location}</Table.Td>
                <Table.Td>{transport.transportation_id}</Table.Td>
              </Table.Tr>
            ))
          : []
      )
    : [];
  

    return (
        <div style={{ padding: '10px' }}>
            <Box style={{ background: '#40404010' }} p={'sm'}>
                <Flex
                    gap="md"
                    justify="space-between"
                    align="center"
                    direction="row"
                    wrap="wrap"

                >
                    {/* <Title order={3}>{datalist?.data?.rows[0]?.product_name}</Title> */}
                    <Title order={3}>Tansport Journey</Title>
                </Flex>
            </Box>
            <Space h={'md'} />
            {/* Table */}

            <Table striped verticalSpacing="md">
                {/* <Table striped className={classes.customtable}> */}
                <Table.Thead>
                    <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                        <Table.Th>Journey ID</Table.Th>
                        <Table.Th>No. of Times</Table.Th>
                        <Table.Th>Journey Type</Table.Th>
                        <Table.Th>Source Location</Table.Th>
                        <Table.Th>Destination Location</Table.Th>
                        <Table.Th>Transport ID</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>{rows}</Table.Tbody>
            </Table>
        </div>
    );
}

export default memo(TableTransport);
